module.exports = __webpack_public_path__ + "static/media/ic_caret_down.375a52e9.svg";